export interface ApiResponseInterface {
  status: ApiResponseStatus;
  code: number;
  message: string;
  data: any;
}

export enum ApiResponseStatus {
  SUCCESS = 'SUCCESS',
  ERROR = 'ERROR',
}
